import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  TextField,
  DialogActions,
  Button,
} from '@material-ui/core';

interface Props {
  onSkip: (frames: number) => void;
  open: boolean;
  onClose: () => void;
  title?: string;
  text?: string;
}

const Skip: React.FunctionComponent<Props> = (props) => {
  const [frames, setFrames] = useState('');

  const handleSkip = () => {
    props.onSkip(parseInt(frames));
    props.onClose();
  };

  return (
    <Dialog open={props.open} onClose={props.onClose} aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title">{props.title || 'Skip frames'}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {props.text || 'Please enter the number of frames to advance (can be negative)'}
        </DialogContentText>
        <TextField
          autoFocus
          margin="dense"
          id="frames"
          label="Frames"
          fullWidth
          value={frames}
          onChange={(event) => setFrames(event.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onClose} color="primary">
          Cancel
        </Button>
        <Button onClick={handleSkip} color="primary">
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default Skip;
